<template>
  <div v-if="dataHome" class="home">
    <img 
      :src="dataHome.banner" 
      alt="torneo de futbol online"
      height="320"
      width="100%"
      @error="setAltImg"
      class="home__img"
    >
    <div class="home__banner">
      <div class="home__banner__header">
        <a href="/" class="home__banner__header__logo">DeporStar</a>
        <div class="home__banner__header__menu">
          <a :href="dataHome.link1" target="_blank" class="home__banner__header__menu__link">¿Qué es DS?</a>
          <a :href="dataHome.link2" target="_blank" class="home__banner__header__menu__link">Servicios</a>
          <router-link 
            :to="{name: 'login'}" 
            class="home__banner__header__menu__btn">Ingresar</router-link>
          <a :href="dataHome.link3" class="home__banner__header__menu__btn">Tienda</a>
        </div>
      </div>
      <div class="home__banner__body">
        <h1 class="home__banner__body__title">{{ dataHome.title }}</h1>
        <h3 class="home__banner__body__text">{{ dataHome.subtitle }}</h3>
        <div class="home__banner__body__actions">
          <router-link :to="{name: 'login'}" class="home__banner__body__actions__btn alert">Crear Torneo</router-link>
          <router-link :to="{name: 'login'}" class="home__banner__body__actions__btn">Comenzar</router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <app-loading />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
// mixins
import { notImageMixin } from '@/mixins/notImageMixin'

export default {
  name: 'Banner',
  mixins: [notImageMixin],
  computed: {
    ...mapGetters({
      loadHome: 'loadHome',
      dataHome: 'dataHome'
    })
  },
}
</script>
<style lang="scss">
  .home {
    width: 100%;
    height: 320px;
    position: relative;
    @include desde($large) {
      height: 500px;
    }
    @include desde($extra-large) {
      height: 700px;
    }
    &__img {
      width: 100%;
      height: 100%;
    }
    &__banner {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background: rgba(2, 17, 7, 0.7);
      &__header {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 1em;
        border-bottom: 1px solid $color-1;
        @include desde($large) {
          height: 60px;
        }
        &__logo {
          color: $color-white;
          font-family: $ff-1;
          font-size: 20px;
          text-decoration: none;
          font-weight: bold;
          @include desde($large) {
            font-size: 26px;
          }
        }
        &__menu {
          display: flex;
          &__link {
            display: none;
            @include desde($large) {
              display: block;
              padding: 3px 15px;
              margin-left: 5px;
              margin-right: 5px;
              color: $color-white;
              font-family: $ff-1;
              font-weight: bold;
              text-decoration: none;
              &:hover {
                cursor: pointer;
                text-decoration: underline;
              }
            }
          }
          &__btn {
            padding: 3px 15px;
            margin-left: 5px;
            margin-right: 5px;
            color: $color-white;
            font-family: $ff-1;
            font-weight: bold;
            &:hover {
              opacity: 0.6;
            }
            @include desde($large) {
              font-size: 16px;
              text-decoration: none;
              background: $color-3;
              width: 130px;
              text-align: center;
              border-radius: 5px;
            }
          }
        }
      }
      &__body {
        width: 100%;
        height: 280px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 10px;
        @include desde($large) {
          height: 440px;
        }
        @include desde($extra-large) {
          height: 640px;
        }
        &__title {
          font-size: 18px;
          font-family: $ff-2;
          color: $color-white;
          text-align: center;
          text-transform: capitalize;
          @include desde($medium) {
            font-size: 20px;
          }
          @include desde($large) {
            font-size: 28px;
          }
          @include desde($extra-large) {
            font-size: 30px;
          }
        }
        &__text {
          font-size: 11px;
          text-align: center;
          font-family: $ff-1;
          color: $color-8;
          font-weight: 100;
          margin-bottom: 1em;
          text-transform: capitalize;
          @include desde($medium) {
            font-size: 14px;
          }
          @include desde($large) {
            font-size: 18px;
          }
          @include desde($extra-large) {
            font-size: 22px;
          }
        }
        &__actions {
          display: flex;
          justify-content: space-around;
          &__btn {
            font-size: 12px;
            padding: 5px 15px;
            color: $color-white;
            text-decoration: none;
            text-transform: capitalize;
            font-family: $ff-1;
            background: $color-3;
            margin: 5px;
            width: 100px;
            text-align: center;
            border-radius: 5px;
            &:hover {
              opacity: 0.6;
            }
            @include desde($medium) {
              font-size: 14px;
              width: 150px;
            }
            @include desde($large) {
              font-size: 16px;
            }
            &.alert {
              background: $color-2;
            }
          }
        }
      }
    }
  }
</style>
